import { AppointmentDTO } from "@gymflow/types";
import {
  DotBadge,
  DotBadgeProps,
} from "apps/portal/src/components/atoms/DotBadge";
import { useTranslation } from "react-i18next";

type BookingStatusAppointmentBadgeProps = {
  appointment: Pick<AppointmentDTO, "status">;
};

export const BookingStatusAppointmentBadge = ({
  appointment,
}: BookingStatusAppointmentBadgeProps) => {
  const { t } = useTranslation();
  return (
    <DotBadge
      intent={
        (
          {
            BOOKED: "lightblue",
            ATTENDED: "success",
            CANCELLED: "warning",
            LATE_CANCELLED: "error",
            NO_SHOW: "error",
          } as {
            [key in AppointmentDTO["status"]]: DotBadgeProps["intent"];
          }
        )[appointment.status]
      }
      size="small"
    >
      {t(`portal.common.appointmentStatus.${appointment.status}`)}
    </DotBadge>
  );
};
